<template>
  <div>
    <!-- About me -->
    <div class="container mx-auto">
      <AboutMe />
    </div>

    <!-- About counter -->
    <!-- <AboutCounter /> -->

    <!-- About counter -->
    <!-- <div class="container mx-auto">
      <AboutClients />
    </div> -->
  </div>
</template>

<script>
import AboutMe from '@/components/about/AboutMe.vue';
// import AboutCounter from '@/components/about/AboutCounter.vue';
// import AboutClients from '@/components/about/AboutClients';
import feather from 'feather-icons';
export default {
  name: 'About',
  components: {
    AboutMe,
    // AboutCounter,
    // AboutClients,
  },
  mounted() {
    feather.replace();
  },
  updated() {
    feather.replace();
  }
}
</script>